import React from 'react';

import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { BudgetOverview } from './BudgetOverview';
import { SecondaryNav } from '../SecondaryNav';
import { NoData, NoDataFilters } from './NoData';
import { getBudgetSavings, getBudgetSearchOptions } from 'utils/apiRequests';
import DownloadProgressBar from 'Data/DownloadData/DownloadProgressBar';
import { Wrapper, LoadingWrapper } from './BudgetOverview.styles';
import isEqual from 'lodash/isEqual';

export class BudgetOverviewContainer extends React.Component {
	state = {
		data: null,
		searchItem: null,
		selectedIndex: null,
		searchOptions: null,
		isNotificationShown: false,
		hasExportError: false,
		...this.getStateFromLocation(),
	};

	componentDidMount() {
		this.fetchData();
	}

	getStateFromLocation() {
		const { location } = this.props;

		if (!location.state) {
			return {};
		}

		const primaryFilter = location.state.primaryFilter;
		const monthNumbers = location.state.monthNumbers;
		const initialState = {
			...(primaryFilter
				? { searchItem: { name: primaryFilter, value: primaryFilter } }
				: {}),
			...(monthNumbers && monthNumbers.length === 1
				? { selectedIndex: Number(monthNumbers[0]) - 1 }
				: {}),
		};

		return initialState;
	}

	componentDidUpdate(prevProps, prevState) {
		const { searchItem, data } = this.state;

		if (!isEqual(searchItem, prevState.searchItem)) {
			if (!searchItem && this.isDataEmpty()) {
				this.setState({ data: null });
			}

			this.fetchData();
		}

		if (!isEqual(data, prevState.data)) {
			this.fetchSearchOptions();
		}
	}

	fetchData = () => {
		const { searchItem } = this.state;
		const params = {
			filter: searchItem && searchItem.name,
		};

		return getBudgetSavings(params).then(data => {
			this.setState({ data });
		});
	};

	fetchSearchOptions = () => {
		return getBudgetSearchOptions().then(values => {
			this.setState({
				searchOptions: values.map(value => ({ name: value, value })),
			});
		});
	};

	selectSearchItem = searchItem => {
		this.setState({
			searchItem,
		});
	};

	clearSearchItem = () => {
		this.setState({
			searchItem: null,
		});
	};

	selectColumn = index => {
		const { selectedIndex } = this.state;
		const newIndex = index === selectedIndex ? null : index;

		this.setState({ selectedIndex: newIndex });
	};

	isDataEmpty = () => {
		const { data } = this.state;

		return (
			data &&
			data.overallSavingsTarget === 0 &&
			data.overallVariance === 0 &&
			data.overallYtdSavings === 0
		);
	};

	closeNotification = () => {
		this.setState({ isNotificationShown: false, hasExportError: false });
	};

	downloadFailed = () => {
		this.setState({ hasExportError: true });
	};

	clearDownloadError = () => {
		this.setState({ hasExportError: false });
	};

	showDownloadNotification = () => {
		this.setState({ isNotificationShown: true });

		setTimeout(() => {
			this.closeNotification();
		}, 5000);
	};

	render() {
		const {
			data,
			searchOptions,
			searchItem,
			selectedIndex,
			isNotificationShown,
			hasExportError,
		} = this.state;
		const { currencySymbol, currency } = this.props;
		const searchConfig = {
			onChange: this.selectSearchItem,
			options: searchOptions,
			selectedOption: searchItem,
		};

		return (
			<Wrapper>
				<SecondaryNav searchConfig={searchConfig} />
				{!data ? (
					<LoadingWrapper>
						<ApLoaderDefault loaderText={() => <ApLoaderText />} />
					</LoadingWrapper>
				) : this.isDataEmpty() ? (
					searchItem ? (
						<NoDataFilters reset={this.clearSearchItem} />
					) : (
						<NoData fetchData={this.fetchData} />
					)
				) : (
					<BudgetOverview
						data={data}
						currencySymbol={currencySymbol}
						currency={currency}
						selectedIndex={selectedIndex}
						selectColumn={this.selectColumn}
						searchItem={searchItem}
						onDownloadError={this.downloadFailed}
						onDownloadSuccess={this.showDownloadNotification}
						onDownloadStart={this.clearDownloadError}
					/>
				)}
				{isNotificationShown && (
					<DownloadProgressBar
						error={hasExportError}
						successMessage="Generating file... You will receive a notification when the file has been generated"
						onClose={this.closeNotification}
					/>
				)}
			</Wrapper>
		);
	}
}
